import {handleFetchError} from "../../helpers/functions.js";
import {ServerApi} from "../../api.js";
import {IBloggerVideoAnimeJson} from "../../../../../nodeserver/structs/database";
import JSX from "../../helpers/react.js";

function VideoBlogPreview(props: {val: IBloggerVideoAnimeJson}){
    return (
        <div className="videoblog-preview last-video bordered">
            {
                !!props.val.has_spoiler &&
                <a className="status-block" href={`/blogger/video/${props.val.id}?time=${props.val.time}`} target="_blank">содержит спойлер</a>
            }
            <div className="last-video-bottom">
                <div className="last-video-head">
                    <a className="author-img" href={`/blogger/${props.val.creator.id}`} target="_blank">
                        <img src={props.val.creator.avatars.small} />
                    </a>
                    <div>
                        <a href={`/blogger/${props.val.creator.id}`} className="author-link" target="_blank">{props.val.creator.nickname}</a>:
                        <a href={`/blogger/video/${props.val.id}?time=${props.val.time}`} target="_blank">{props.val.title}</a>
                    </div>
                </div>
                <div className="last-video-footer">
                    <div>Категория: <a href={`/blogger?category_id=${props.val.category.id}`} target="_blank">{props.val.category.title}</a></div>
                    <div>
                        <i title="Количество комментариев" className="fa fa-comments" /> {props.val.comments_count} <i title="Дата публикации" className="far fa-calendar-alt" /> <local-time data-time={props.val.publish_date} data-only-date="1" />
                    </div>
                </div>
            </div>
            <a href={`/blogger/video/${props.val.id}?time=${props.val.time}`} className="last-video-image" target="_blank">
                <img src={props.val.previews.big} alt="Картинка" />
            </a>
        </div>
    )
}
class VideoBlogBlock{
    private $element: JQuery;
    private constructor(private readonly val: IBloggerVideoAnimeJson) {
        this.$element = this.buildHtml();
    }
    private buildHtml(): JQuery{
        const $ans = $(<VideoBlogPreview val={this.val} />)
            .data('item', this);
        return $ans;
    }
    static get items() : VideoBlogBlock[]{
        return Array.from($('.videoblog-preview')).map(e=>$(e).data('item') as VideoBlogBlock);
    }
    static generateElement(data: IBloggerVideoAnimeJson, $container: JQuery){
        const el = new VideoBlogBlock(data);
        el.$element.appendTo($container);
        return el;
    }
}


$(document).on('click', '#animevideobloggers-button', reloadAnimes);


async function reloadAnimes(){
    const loadingThing = $("#videobloggers .loading-thing"),
        container = $('#videobloggers .container')
    try{
        loadingThing.css('display', 'block');
        const offset = VideoBlogBlock.items.length;
        const videos = await ServerApi.bloggers.getAnimeVideos(page_id!, offset);
        for(const video of videos){
            VideoBlogBlock.generateElement(video, container);
        }
        if(videos.length >= 24){
            $('<button class="main-button" style="left: 50%;transform: translateX(-50%);margin-top:5px;">Загрузить ещё</button>')
                .on('click', function (){
                    $(this).remove();
                    reloadAnimes();
                })
                .appendTo('#videobloggers');
        }
    }catch (e){
        handleFetchError(e);
    }
    finally {
        loadingThing.css('display', 'none');
    }
}